// extracted by mini-css-extract-plugin
export default {"container":"DZ-z","title":"EZ-z","link":"FZ-z"};